import '@/styles/iconfont/iconfont.css'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import Vue from 'vue'
import * as Sentry from '@sentry/vue'

import '@/styles/bootstrap-css-utils.css'
import { dataBase } from 'blm-utils'
// import VueAMap from 'vue-amap'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'

import '@/styles/index.scss' // global css
// 从leopard-web-component迁移过来的公共样式
import '@/styles/theme/base.scss'
import '@/styles/theme/elment-ui.scss'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

import '@/framework/components'
import '@/framework/directive' // 自定义指令
import '@/framework/directive/inputNumber/index' // 数字 input 自定义指令
import '@/framework/filters' // 自定义指令
import '@/utils/monitor' // 监控

import { baMixin } from '@/ba' // 埋点
import Mixin from '@/framework/mixins'

import '@/mock/mockData' // 引入Mock数据文件 待接入环境变量~~~~~
import Fragment from 'vue-fragment' // 全局公共组件
// const blmMonitor = window.__blmMonitor;
// blmMonitor && blmMonitor.monitor && blmMonitor.monitor.init({
//   channel: 'web', // 渠道
//   pid: 'vehicle_web', // p_业务线_业务
//   Vue // 如果是vue 项目则传入Vue构造函数对象
// });

Vue.prototype.dataBase = new dataBase.DB('blm-vehicle', 'qps') // blm-vehicle-数据库名，qps-表名
// 私有服UI的npm包====必须放在element-ui的前面，不然element-ui的size:small会失效
// import leopardWebComponent from 'leopard-web-component'
// import 'leopard-web-component/lib/leopard-web-component.css'

// import PegasusAuxComponent from 'pegasus-aux-component'
// import 'pegasus-aux-component/dist/pegasus-aux-component.css'
// const echarts = require('echarts') // 引入echart

Vue.use(VueClipboard)
Vue.mixin(Mixin)
// Vue.prototype.$echarts = echarts
const EventBus = new Vue()
Vue.prototype.$EventBus = EventBus
Vue.use(Fragment.Plugin)

Vue.prototype.$tours = {}

Vue.prototype.$ELEMENT = {
  size: 'small',
  zIndex: 2000,
}

Vue.use(ElementUI, { size: 'small', locale })
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '55897440ff54932c599cc73b9b4baf1c',
//   plugin: ['AMap.ToolBar', 'AMap.PolyEditor', 'AMap.CircleEditor', 'Geocoder', 'AMap.CitySearch'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// })

// 删除当前tab 并触发刷新
Vue.prototype.$refreshBack = function (refreshStatus) {
  let componentInstance = null
  if (this.$vnode?.parent) {
    componentInstance = this.$vnode?.parent?.componentInstance
  }
  const dataKey = this.$vnode?.data?.key // 暂时无用

  this.$EventBus.$emit('deleteCurrentRoute', componentInstance, dataKey, this.$route, refreshStatus)
}
Vue.prototype.$refreshParent = function () {
  this.$EventBus.$emit('refreshParent', this.$route)
}

Vue.prototype.$to = function (promise) {
  return promise.then((data) => [null, data]).catch((err) => [err])
}

Vue.config.productionTip = false
window.UEDITOR_HOME_URL = process.env.UEDITOR_HOME_URL

// sentry监控
Sentry.init({
  Vue,
  dsn: 'https://7953b581acdcb494cdd26aeaea821c3d@sentry.cheweijia.com/2',
  environment: process.env.NODE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: [window.location.origin],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay({ networkDetailAllowUrls: [window.location.origin] }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

router.afterEach((to) => {
  Sentry.captureMessage(to.path, {
    extra: {
      query: to.query,
    },
    tags: {
      type: 'pv',
    },
  })
})

const app = new Vue({
  router,
  store,
  mixins: [baMixin],
  render: (h) => h(App),
})
app.$mount('#app')
